import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import Countdown from "react-countdown";
import { sendSmsOfferValidation } from "../../../services/calculation.service";
import { saveMembership_Begin } from "../../../state/ducks/calculation/index";
import { withRouter } from "react-router";
import Modal from "../Modal/index";
import $ from "jquery";
import NumberFormat from "react-number-format";

const SmsVerification = ({
  orgTuruId,
  selectedCampaign,
  selectedCampaignPaymentPlan,
  saveMembership_Begin,
  history,
  alert,
  error,
}) => {
  useEffect(() => {
    if (selectedCampaign === undefined) {
      history.push("/Home/SmartCalculation");
    }
  }, []);

  const [state, setState] = useState({
    code: null,
    resendCode: false,
    countDate: Date.now() + 180000,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const timerEnd = () => {
    setState({ resendCode: true });
    $("#code").prop("disabled", true);
    $("#submit").prop("disabled", true);
    $("#submit").css("pointer-events", "none");
    $("#tekrar_gonder").css("pointer-events", "all");
  };

  const resend = () => {
    setState({ resendCode: false, countDate: Date.now() + 180000 });
    $("#code").prop("disabled", false);
    $("#submit").prop("disabled", false);
    $("#submit").css("pointer-events", "all");
    $("#tekrar_gonder").css("pointer-events", "none");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    debugger;

    let ilkTeslimTarihi =
      selectedCampaignPaymentPlan.uyelik.ilkTeslimTarihi.split("-");
    let year = ilkTeslimTarihi[0];
    let month = ilkTeslimTarihi[1];
    let day = "01";

   ilkTeslimTarihi = year + "-" + month + "-" + day;

    const model = {
      DogrulamaKod: state.code,
      KampanyaId: selectedCampaign.id,
      TaksitSayisi: selectedCampaignPaymentPlan.uyelikHareketModelList.length,
      OrgUcreti: selectedCampaign.calcOrganizasyonUcreti,
      OrgUcretiKdvDahil: selectedCampaignPaymentPlan.uyelik.orgUcretiKdvDahil,
      PesinatTutar: selectedCampaignPaymentPlan.uyelik.pesinatTutar,
      OrgTutar: selectedCampaignPaymentPlan.uyelik.orgTutar,
      IlkTeslimTarihi: ilkTeslimTarihi,
      TaksitTutar: selectedCampaignPaymentPlan.uyelikHareketModelList[0].tutar,
      // OfferDetailModelList: selectedCampaignPaymentPlan.uyelikHareketModelList,
      OrgSistemiId: selectedCampaign.organizasyonSistemiId,
      OrgTuruId: orgTuruId,
      SonTeslimDonem: selectedCampaignPaymentPlan.uyelikModel.sonTeslimDonem,
      ToplamMaliyet: selectedCampaignPaymentPlan.uyelik.orgTutar + selectedCampaignPaymentPlan.uyelik.orgUcretiKdvDahil,
    };
    saveMembership_Begin(model);
  };

  return (
    <div className="container-fluid">
      {/* yesil Alan*/}
      <div className="row" style={{ padding: "3%" }}>
        <div className="col-12">
          {/* KUTU 1 */}
          <div className="row no-gutters t-kutu t-yesilCizgi">
            <div
              className="col bosluk backtop"
              style={{
                backgroundImage: 'url("/assets/img/backgrounds/back_top_yesil.jpg")'
              }}
            >
              {/* içerikler */}
              {/* Başlık */}
              <div className="row no-gutters pb-4">
                <div className="col-12 d-flex justify-content-center pb-2">
                  <i className="t-icon-lock_clock t-icGenelBaslikIcon" />
                </div>
                <div className="col-12 d-flex justify-content-center pb-3 t-icGenelBaslik">
                  SMS DOĞRULAMA
                </div>
                <Modal isOpen={alert.isOpen} message={error} type={"danger"} />
                <div className="col-12 text-center t-icYazilar">
                  Lütfen telefonunuza gelen şifreyi giriniz.
                </div>
              </div>
              {/* Kod */}
              <div className="row no-gutters my-4 d-flex justify-content-center flex-column align-items-center">
                <div className="col-auto pb-1">
                  <span className="t-icInputTitle pl-3 text-center">SMS Kodu</span>
                </div>
                <div className="col-auto pb-4">
                  <div className="t-icInput" style={{ maxWidth: 350 }}>
                    <div>
                      <i className="t-icon-phonelink_lock" />
                    </div>
                    <NumberFormat
                      displayType={"input"}
                      maxLength="6"
                      minLength="6"
                      id="code"
                      name="code"
                      placeholder="Sms Kodu"
                      value={state.code}
                      onChange={handleChange}
                      required={true}
                    />
                    <div />
                  </div>
                </div>
                <div
                  className="col-auto"
                  style={{ color: "#0c9908", fontWeight: "bold", display: state.resendCode ? "none" : "block"}}
                >
                  <i className="t-icon-clock pr-2" />
                  Kalan süre {" "}
                  <Countdown
                      key={state.countDate}
                      date={state.countDate}
                      renderer={({ total }) => (
                        <strong id="count_down">
                          <strong>{total / 1000} {" "}sn</strong>
                        </strong>
                      )}
                      onComplete={() => {
                        timerEnd();
                      }}
                    ></Countdown>
                </div>
                {/* Geri Sayım JS si*/}
                {/* Geri Sayım JS si BİTTİ*/}
              </div>
              {/* Değiştir*/}
              <div className="row no-gutters d-flex align-items-center justify-content-center">
                <div className="col-auto px-1">
                  <button type="button" className="t-icButonTrunucu"
                   id="tekrar_gonder"
                   onClick={() => {
                    sendSmsOfferValidation();
                    resend();
                  }}>
                    <i className="t-icon-loop2 px-2" style={{ fontSize: "14pt" }} />
                    <span />
                    <span className="pb-1">Tekrar Gönder</span>
                  </button>
                </div>
                <div className="col-auto px-1">
                  <button
                    type="button"
                    className="t-icButtonYesil"
                    id="submit"
                    onClick={handleSubmit}
                  >
                    <span />
                    <span className="pb-1">Doğrula</span>
                    <i
                      className="t-icon-arrow-right2"
                      style={{ fontSize: "14pt" }}
                    />
                  </button>
                </div>
              </div>
              {/* içerikler BİTTİ */}
            </div>
            <div className="col-auto renk" />
          </div>
          {/* KUTU 1 BİTTİ */}
        </div>
      </div>
      {/* Duyurlar Baslık*/}
      {/* duyrular Bitti*/}
      <div className="row" style={{ height: 30 }} />
    </div>

  );
};

const mapStateToProps = (state) => ({
  orgTuruId: state.calculation.orgTuruId,
  selectedCampaign: state.calculation.selectedCampaign,
  selectedCampaignPaymentPlan: state.calculation.paymentPlan,
  alert: state.alert,
  error: state.calculation.error,
  isCandidateProcessCompleted: state.calculation.isCandidateProcessCompleted,
});

const mapDispatchToProps = (dispatch) => ({
  saveMembership_Begin: (membership) =>
    dispatch(saveMembership_Begin(membership)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SmsVerification);
